import { useState, useEffect } from 'react';
import { TopToolbar, AutocompleteInput, TextField, useRecordContext, ExportButton, Button, List, Datagrid, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField, useRefresh, useNotify } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';
import { fetcherSync } from "../utils/fetcher";
import config from "../config";
import * as React from 'react';
import Typography from '@mui/material/Typography';
import {default as MUITextField} from '@mui/material/TextField';
import {default as MUIButton} from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const TransactionTypeComponent = () => {
    const record = useRecordContext();
    if (!record) return null;
    
    var style = {
        height: "20px",
        display: "block",
        lineHeight: "20px",
        padding: "5px",
        textAlign: "center",
        backgroundColor: "#7f8c8d",
        borderRadius: "10px",
        color: "#ecf0f1",
        fontWeight: "bold"
    }
    if(record.type.localeCompare("payment") == 0){
        return (
            <span style={{...style, backgroundColor: "#27ae60"}}>Paiement client</span>
        );
    }
    else if(record.type.localeCompare("refund") == 0){
        return (
            <span style={{...style, backgroundColor: "#c0392b"}}>Remboursement</span>
        );
    }
    else if(record.type.localeCompare("addition") == 0){
        return (
            <span style={{...style, backgroundColor: "#8e44ad"}}>Supplément</span>
        );
    }
    return (
        <span style={{...style, backgroundColor: "#7f8c8d"}}>{record.type}</span>
    );
};

const TransactionStatusComponent = () => {
    const record = useRecordContext();
    if (!record) return null;
    
    var style = {
        display: "block",
        lineHeight: "20px",
        padding: "5px",
        textAlign: "center",
        backgroundColor: "#7f8c8d",
        borderRadius: "10px",
        color: "#ecf0f1",
        fontWeight: "bold"
    }
    if(record.status.localeCompare("succeeded") == 0){
        return (
            <span style={{...style, backgroundColor: "#27ae60"}}>Validé</span>
        );
    }
    /*else if(record.stripe.status.localeCompare("requires_payment_method") == 0){
        return (
            <span style={{...style, backgroundColor: "#c0392b"}}>Paiement refusé</span>
        );
    }
    else if(record.stripe.status.localeCompare("canceled") == 0){
        return (
            <span style={{...style, backgroundColor: "#7f8c8d"}}>Paiement annulé</span>
        );
    }*/
    else if(record.status.localeCompare("created") == 0){
        return (
            <span style={{...style, backgroundColor: "#f39c12"}}>En attente</span>
        );
    }
    /*else if(record.stripe.status.localeCompare("complete") == 0){
        return (
            <span style={{...style, backgroundColor: "#27ae60"}}>Paiement effectué</span>
        );
    }*/
    else if(record.status.localeCompare("expired") == 0){
        return (
            <span style={{...style, backgroundColor: "#7f8c8d"}}>Expiré / Lien désactivé</span>
        );
    }
    return (
        <span style={{...style, backgroundColor: "#7f8c8d"}}>{record.stripe.status}</span>
    );
};

const TransactionAmountComponent = () => {
    const record = useRecordContext();
    if (!record) return null;

    return (
        <span>{record.amount/100} {record.currency}</span>
    );
};

const TransactionActionsComponent = () => {
    const record = useRecordContext();
    const [hoverCopy, setHoverCopy] = useState(false);
    const [hoverDelete, setHoverDelete] = useState(false);
    if (!record) return null;
    
    var styleBlack = {
        color: "black",
        padding: "5px",
        cursor: "pointer"
    }
    var styleRed = {
        color: "#c0392b",
        padding: "5px",
        cursor: "pointer"
    }
    var styleHover = {
        color: "#2980b9"
    }

    function copyToClipboard(text){
        let temp = document.createElement('textarea');
        temp.value = text;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
        alert("Lien copié.");
    }

    function cancelSession(transactionId){
        fetcherSync(config.API_HOST+"/orderTransactions/session/"+transactionId+"/cancel", "PUT");
        alert("Lien désactivé.")
    }

    function reimburse(amount, amountRefunded, currency, intentId, orderId){
        let valeur = prompt("Quel montant souhaitez-vous rembourser sur les "+((amount-amountRefunded)/100)+" "+currency+" restants ?");
        if(valeur){
            valeur = valeur.replaceAll(",", ".")
            let cents = valeur*100;
            if(Number.isInteger(cents)){
                if(cents <= (amount - amountRefunded)){
                    let result = fetcherSync(config.API_HOST+"/orders/"+orderId+"/intent/"+intentId+"/refund", "PUT", {intentId: intentId, amount: cents});
                    if(result.status && result.status.localeCompare("succeeded") == 0){
                        alert("Remboursement effectué.");
                        setTimeout(() => document.location.reload(true), 1000)
                    }
                    else {
                        alert(result.message);
                    }
                }
                else {
                    alert("Le montant est trop grand.")
                }
            }
            else {
                alert("Veuillez rentrer une valeur correcte.")
            }
        }
    }

    function reimburseSubscription(amount, amountRefunded, currency, transactionId, orderId){
        let valeur = prompt("Quel montant souhaitez-vous rembourser sur les "+((amount-amountRefunded)/100)+" "+currency+" restants ?");
        if(valeur){
            valeur = valeur.replaceAll(",", ".")
            let cents = valeur*100;
            if(Number.isInteger(cents)){
                if(cents <= (amount - amountRefunded)){
                    let result = fetcherSync(config.API_HOST+"/orders/"+orderId+"/transaction/"+transactionId+"/refundSubscription", "PUT", {amount: cents});
                    if(result.status && result.status.localeCompare("succeeded") == 0){
                        alert("Remboursement effectué.");
                        setTimeout(() => document.location.reload(true), 1000)
                    }
                    else {
                        alert(result.message);
                    }
                }
                else {
                    alert("Le montant est trop grand.")
                }
            }
            else {
                alert("Veuillez rentrer une valeur correcte.")
            }
        }
    }

    if(record.transactionId.localeCompare("subscription_transaction") == 0 && record.totalAmountRefunded < record.amount){
        return (
            <div>
                <a onClick={() => reimburseSubscription(record.amount, record.totalAmountRefunded, record.currency, record.id, record.orderId)} style={{...styleBlack, ...(hoverCopy ? styleHover : null)}} onMouseEnter={() => setHoverCopy(true)} onMouseLeave={() => setHoverCopy(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wallet" viewBox="0 0 16 16">
                        <path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"/>
                    </svg>
                </a>
            </div>
        );
    }
    else if(record.type.localeCompare("addition") == 0 && record.status.localeCompare("created") == 0){
        return (
            <div>
                <a onClick={() => copyToClipboard(record.url)} style={{...styleBlack, ...(hoverCopy ? styleHover : null)}} onMouseEnter={() => setHoverCopy(true)} onMouseLeave={() => setHoverCopy(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                    </svg>
                </a>
                <a onClick={() => cancelSession(record.transactionId)} style={{...styleRed, ...(hoverDelete ? styleHover : null)}} onMouseEnter={() => setHoverDelete(true)} onMouseLeave={() => setHoverDelete(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </a>
            </div>
        );
    }
    else if(record.type.localeCompare("payment") == 0 && record.totalAmountRefunded < record.amount){
        return (
            <div>
                <a onClick={() => reimburse(record.amount, record.totalAmountRefunded, record.currency, record.transactionId, record.orderId)} style={{...styleBlack, ...(hoverCopy ? styleHover : null)}} onMouseEnter={() => setHoverCopy(true)} onMouseLeave={() => setHoverCopy(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wallet" viewBox="0 0 16 16">
                        <path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"/>
                    </svg>
                </a>
            </div>
        );
    }
    else {
        return <span>Aucune action</span>;
    }
};

export const OrderTransactionList = (props) => {
    var record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();
    if (!record || !record.id) return <span>Chargement</span>;

    var orderId = record.id;


    const refreshOrderTransactions = () => {
        if(record != undefined){
            notify("Rafraîchissement en cours ...")
            let result = fetcherSync(config.API_HOST+"/orders/"+record.id+"/refreshOrderTransactions", "POST");
            refresh();
           // window.location.reload(true);
        }
    }

    return (
        <>
            <List exporter={false} filter={{ orderId: orderId }} style={{width: "100%"}} resource="orderTransactions" basePath="" perPage={25}>
                <Datagrid>
                    <TextField source="transactionId" label="ID de la transaction" />
                    <TransactionAmountComponent label="Montant" />
                    <TransactionTypeComponent label="Type"/>
                    <TransactionStatusComponent label="Status"/>
                    <TransactionActionsComponent label="Actions" />
                </Datagrid>
            </List>

            <MUIButton style={{margin: "auto"}} variant="contained" color="success" onClick={() => {refreshOrderTransactions()}}>Rafraîchir les transactions</MUIButton>
        </>
    )
};

export const CreateTransactionForm = (props) => {
    var record = useRecordContext();

    const [amount, setAmount] = React.useState("");

    if (!record || !record.products || !record.productsIds || !record.id) return <span>Chargement</span>;

    var orderId = record.id;

    function handleSubmit(event) {
        let cents = amount.replaceAll(",", ".");
        cents = cents*100;
        if(Number.isInteger(cents)){
            let result = fetcherSync(config.API_HOST+"/orders/"+orderId+"/transaction/add", "POST", {
                amount: cents,
                successUrl: config.WEBSITE_URL+"/page/paiement-valide",
                cancelUrl: config.WEBSITE_URL+"/page/paiement-refuse",
            });
            if(result.status && result.status.localeCompare("open") == 0){
                alert("Lien de paiement créé : "+result.url);
            }
            else {
                alert(result.message);
            }
        }
        else {
            alert("Veuillez rentrer un montant valide.")
        }
        event.preventDefault();
    }

    const titleStyle = {
        textAlign: "center",
        width: "100%",
        padding: 15,
        color: "rgb(80, 80, 80)"
    };

    return (
        <div style={{width: "100%"}}>
            <Typography variant="h5" component="h6" style={titleStyle}>
                Création d'un supplément
            </Typography>

            <Stack direction="row" spacing={2} justifyContent="center">
                <MUITextField id="filled-basic" label="Montant" variant="filled" value={amount} onChange={(e) => setAmount(e.target.value)} />

                <MUIButton variant="contained" onClick={handleSubmit}>Créer</MUIButton>
            </Stack>
        </div>
    )
};